export default __webpack_public_path__ + "static/media/kitchen5-afterB.6a3b5248.jpg";